export const checkoutPageMessage = new Map([
  ['fname', 'Vul alstublieft het veld \'Voornaam\' in.'],
  ['lname', 'Vul alstublieft het veld \'Achtenaam\' in.'],
  ['emptyAdd', 'Vul alstublieft een address in.'],
  ['emptycity', 'Vul alstublieft een stad in.'],
  ['emptyEmail', 'Vul alstublieft het veld \'E-mail\' in.'],
  ['invalidEmail', 'Vul alstublieft een geldig \'E-mail\' address in.'],
  ['phone', 'Vul alstublieft het veld \'GSM\' in.'],
  ['weakpass', 'Wachtwoord lengte moet 6 of meer zijn.'],
  ['mismatchPass', 'Bevestig wachtwoord is niet hetzelfde.'],
  ['passlogin', 'Vul alstublieft het veld \'Wachtwoord\' in.'],
]);
